import { ModalDialog } from 'components/ModalDialog';
import { RequestStatus } from 'features/request/requestSlice';
import { WorkOrderPriceTypeEnum } from 'gql/graphql';

import { TextField } from '@consta/uikit/TextField';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import './editRationale.css';

import { useUpdateWorkOrderOtherPriceRationale } from './hooks/useUpdateWorkOrderOtherPriceRationale';
import { useUpdateWorkOrderPriceRationale } from './hooks/useUpdateWorkOrderPriceRationale';

interface IEditRationaleDialog {
    refreshData: () => void;
    itemId?: number;
    itemCode?: string | null;
    itemName?: string | null;
    itemNote?: string | null;
    itemType?: WorkOrderPriceTypeEnum | null;
    onClose?: () => void;
}

export const EditRationaleDialog = (props: IEditRationaleDialog) => {
    const { itemId, refreshData, onClose, itemType, itemNote, itemName, itemCode } = props;

    const navigate = useNavigate();
    const { state } = useLocation();

    const type = useMemo(() => itemType ?? state?.type, [itemType, state?.type]);

    const isOther = type === WorkOrderPriceTypeEnum.Other;

    const [rationale, setRationale] = useState(itemNote ?? state?.rationale);

    const { uerUpdateWorkOrderPriceRationaleStatus, updateWorkOrderPriceRationaleHandler } =
        useUpdateWorkOrderPriceRationale();

    const { uerUpdateWorkOrderOtherPriceRationaleStatus, updateWorkOrderOtherPriceRationaleHandler } =
        useUpdateWorkOrderOtherPriceRationale();

    const handleClickOutside = useCallback(() => {
        if (onClose) {
            onClose();
        } else {
            navigate('../', { replace: true });
        }
    }, [navigate, onClose]);

    const handleModalConfirm = useCallback(() => {
        if (isOther) {
            updateWorkOrderOtherPriceRationaleHandler(rationale, itemId ?? state?.id);
        } else {
            updateWorkOrderPriceRationaleHandler(rationale, itemId ?? state?.id);
        }
        setTimeout(() => {
            refreshData();
        });
        if (onClose) {
            onClose();
        } else {
            navigate('../', { replace: true });
        }
    }, [
        isOther,
        itemId,
        navigate,
        onClose,
        rationale,
        refreshData,
        state?.id,
        updateWorkOrderOtherPriceRationaleHandler,
        updateWorkOrderPriceRationaleHandler,
    ]);

    const onChangeHandler = useCallback(({ value }: { value: string | null }) => {
        setRationale(value ?? '');
    }, []);

    useEffect(() => {
        if (!state && !itemId) {
            handleClickOutside();
        }
    }, [handleClickOutside, itemId, state]);

    return (
        <ModalDialog
            title="Редактирование примечания"
            isOpen
            hasOverlay
            withTitleCloseButton
            isCommit={[uerUpdateWorkOrderPriceRationaleStatus || uerUpdateWorkOrderOtherPriceRationaleStatus].includes(
                RequestStatus.FETCHING,
            )}
            onClose={handleClickOutside}
            onConfirm={handleModalConfirm}
            btnConfirmLabel="Сохранить"
            btnCancelLabel="Отменить"
            style={{ overflow: 'hidden' }}
        >
            <div id="EditRationaleDialog">
                <div style={{ width: '520px', padding: '20px' }}>
                    <p className="title">{itemCode ?? state?.code}</p>
                    <p className="subTitle">{itemName ?? state?.name}</p>
                    <TextField
                        name="note"
                        value={rationale}
                        onChange={onChangeHandler}
                        width="full"
                        type="textarea"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        autoCapitalize="off"
                        minRows={6}
                    />
                </div>
            </div>
        </ModalDialog>
    );
};

EditRationaleDialog.displayName = 'EditRationaleDialog';
